var Position;
(function (Position) {
    Position["left"] = "left";
    Position["right"] = "right";
    Position["top"] = "top";
    Position["bottom"] = "bottom";
})(Position || (Position = {}));
var InfoState;
(function (InfoState) {
    InfoState["info"] = "info";
    InfoState["alarm"] = "alarm";
    InfoState["warning"] = "warning";
    InfoState["success"] = "success";
    InfoState["safe"] = "safe";
})(InfoState || (InfoState = {}));
var ComponentDirection;
(function (ComponentDirection) {
    ComponentDirection["row"] = "row";
    ComponentDirection["column"] = "column";
})(ComponentDirection || (ComponentDirection = {}));
var EmphasisLM;
(function (EmphasisLM) {
    EmphasisLM["LOW"] = "LOW";
    EmphasisLM["MEDIUM"] = "MEDIUM";
})(EmphasisLM || (EmphasisLM = {}));
var Emphasis;
(function (Emphasis) {
    Emphasis["LOW"] = "LOW";
    Emphasis["MEDIUM"] = "MEDIUM";
    Emphasis["HIGH"] = "HIGH";
})(Emphasis || (Emphasis = {}));

export { ComponentDirection, Emphasis, EmphasisLM, InfoState, Position };
